import React from "react";
import { Link, useLocation } from "react-router-dom";

const CheckoutBreadcrumb = () => {
  const location = useLocation();

  // previous path (fallback to cart)
  const fromPath = location.state?.from || "/cart";

  const getLabel = (path) => {
    if (path === "/") return "Home";
    if (path.includes("/product")) return "Product";
    if (path.includes("/cart")) return "Cart";
    if (path.includes("/store")) return "Store";
    return "Back";
  };

  return (
    <>
      {/* Inline CSS for perfect alignment */}
      <style>
        {`
          .checkout-breadcrumb .breadcrumb {
            display: flex;
            align-items: center;
            gap: 6px;
            padding: 0;
            margin: 0;
            background: transparent;
          }

          .checkout-breadcrumb .breadcrumb-item,
          .checkout-breadcrumb .breadcrumb-divider {
            font-size: 14px;
            line-height: 1;
            display: flex;
            align-items: center;
          }

          .checkout-breadcrumb .breadcrumb-divider {
            color: #6c757d;
          }

          .checkout-breadcrumb .breadcrumb-item a {
            text-decoration: none;
            color: #000;
          }

          .checkout-breadcrumb .breadcrumb-item.active {
            color: #6c757d;
            font-weight: 600;
          }
        `}
      </style>

      <nav aria-label="breadcrumb" className="checkout-breadcrumb mb-2">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <Link className="total-price" to={fromPath} style={{minHeight:"auto"}}>
              {getLabel(fromPath)}
            </Link>
          </li>

          <li className="breadcrumb-divider">/</li>

          <li
            className="breadcrumb-item total-price active fw-bold"
            aria-current="page"
          >
            Checkout
          </li>
        </ol>
      </nav>
    </>
  );
};

export default CheckoutBreadcrumb;
